export default {
  postureReport: "体态报告",
  postureData: "体态数据",
  postureDataContrast: "体态数据对比",
  postureRiskContrast: "体态风险对比",
  postureDataTrend: "体态数据趋势",
  postureRiskTrend: "体态风险趋势",
  postureLogData: "体态日志数据",
  lateralhead: "头部侧倾",
  unevenshoulder: "高低肩",
  scoliosis: "脊柱异位",
  unevenhip: "骨盆侧倾",
  xleg: "X型腿",
  oleg: "O型腿",
  roundedshoulder: "圆肩",
  kneehyperextension: "膝过伸",
  trunkforwardtilt: "躯干倾角（矢状面）",
  trunklateraltilt: "躯干倾角（冠状面）",
  ankleheelleft: "足跟内外翻（左）",
  ankleheelright: "足跟内外翻（右）",
  forwardhead: "头部前倾",
  toTheLeft: "(左倾)",
  toTheRight: "(右倾)",
  bracketsLeft: "(左)",
  bracketsRight: "(右)",
  bracketsNormal: "(正常)",
  leg: "腿型",
  legLeft: "腿型（左）",
  legRight: "腿型（右）",
  riskAssessment: "风险评估",
  muscleState: "肌肉状态",
  muscleStateDesc: "未发现肌肉状态异常",
  testTime: "检测时间",
  hRisk: "高",
  mRisk: "中",
  lRisk: "低",
  item: "项",
  degree: "度",
  percent: "%",
  mm: "mm",
  moireImage: "云纹图",
  lAbnormalRisk: "低风险",
  mAbnormalRisk: "中风险",
  hAbnormalRisk: "高风险",
  highRisk: "高分险",
  riskAnalysis: "风险解析",
  conclusionRecommendation: "结论建议",
  solution: "解决方案",
  movePosition: "点击圆点可移动位置",
  confirmTheClose: "暂未保存确认关闭吗",
  closeInfo: "暂未保存确认关闭吗",
  share: "分享",
  front: "正面",
  side: "侧面",
  back: "背面",
  otherSide: "另一侧",
  points: "分",
  angle: "角度",
  name: "姓名",
  gender: "性别",
  male: "男",
  female: "女",
  age: "年龄",
  year: "岁",
  height: "身高",
  weight: "体重",
  time: "时间",
  patientId: "就诊号",
  save: "保存",
  saveModify: "保存修改",
  print: "打印",
  cancel: "取消",
  zoomIn: "放大",
  zoomOut: "缩小",
  ok: "确定",
  return: "返回",
  empty: " ",
  unknown: "未知",
  succeedToCopy: "复制成功",
  succeedToSave: "保存成功",
  failedToSave: "保存失败",
  reload: "重新加载",
  loading: "数据加载中...",
  toolbox: "工具箱",
  protractor: "量角器",
  ruler: "直尺",
  drag: "拖动",
  mirror: "镜像",
  crop: "截取",
  point: "标点",
  vertical: "垂线",
  horizontal: "水平线",
  verticalAngle: "垂线夹角",
  horizontalAngle: "水平夹角",
  headForwardDistance: "头部前移距离",
  pelvisForwardTilt: "骨盆前倾角",
  wristHipDistanceLeft: "腕髋距离（左）",
  wristHipDistanceRight: "腕髋距离（右）",
  evaluator: "评估者",
  reportDate: "报告日期",
  introduction: "简介",
  doctorIntroDefault: "专业领域：康复医学、体态评估与矫正 | 从业年限：5年以上 |：运动损伤康复、姿势纠正、疼痛管理",
  recoveryLog: "康复日志",
  returnToReport: "返回报告",
  showToolbox: "显示工具箱",
  hideToolbox: "隐藏工具箱",
};
